import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';
import Config from 'Config';

export async function deleteAdmin(userId, businessId) {
  const apiPath = `permission/remove-admin-status`;

  const request = {
    //url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    region: Config.AWS_REGION,
    service: 'execute-api',
    method: 'DELETE',
    body: JSON.stringify({ userId, businessId }),
    data: { userId, businessId },
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
}
